// extracted by mini-css-extract-plugin
module.exports = {"ProfileToggle":"ExtranetProfileMenu_ProfileToggle__2mZ02"};